import { Controller } from 'stimulus'

export default class VisiblityToggle extends Controller {
  static targets = ['target', 'input', 'forceHide'];

  connect() {
    if (this.element.dataset["visibilityTargetInitialToggle"] !== "false") {
      this.toggle({ preventDefault: () => { } });
    }
  }

  forceHideTargetConnected() {
    this.hide();
  }

  toggle(e) {
    if (this.element.dataset["visibilityTargetPreventDefault"] !== "false") {
        e.preventDefault();
    }

    let currentValue = null;
    if (this.hasInputTarget) {
      switch(this.inputTarget.type) {
        case "checkbox":
          currentValue = this.inputTarget.checked;
          break;
        case "radio":
          currentValue = this.inputTargets.filter((input) => input.checked).map((input) => input.value);
          break;
        default:
          currentValue = this.inputTarget.value;
          break;
      }
      currentValue = currentValue.toString();
    }

    this.targetTargets.forEach((target) => {
      let shouldShow = true;

      if (target.dataset.triggerValue) {
        const triggerValues = target.dataset.triggerValue.split(',');
        shouldShow = triggerValues.includes(currentValue);
      }

      // use hidden attribute
      target.hidden = !shouldShow;

      // preserve existing behavior for .hidden class
      if (shouldShow) {
        target.classList.remove('hidden');
      } else {
        target.classList.add('hidden');
      }
    });
  }

  hide() {
    if (this.hasInputTarget && this.inputTarget.type === "checkbox") {
      this.inputTarget.checked = false;
      // Manually trigger toggle to update the UI
      this.toggle({ preventDefault: () => {} });
    }
  }
}
